import React from 'react';
import { makeStyles } from '@material-ui/core';
import zubaleMark from './zubale-mark.png';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  wordmark: {
    marginLeft: 8,
    color: '#ffffff',
    fontSize: 20,
    fontWeight: 700,
    letterSpacing: 0.2,
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <img src={zubaleMark} alt="Zubale" height={30} width={30} />
      <span className={classes.wordmark}>Zubale</span>
    </div>
  );
};

export default LogoFull;
